// Online exams update immediately after start/answer/advance. Countdown runs
// locally; the server remains authoritative for deadlines and answer locking.
// Jitter prevents thousands of browsers from polling at the same instant.
export function livePollDelayMs(mode, random = Math.random) {
  return mode === "online_exam" ? 12000 + Math.floor(random() * 6000) : 1250;
}

export function acceptPolledState(previous, incoming) {
  // A poll started before an answer must not put the previous question back.
  if (previous?.session_id === incoming?.session_id && (
      Number(previous?.attempt_revision ?? -1) > Number(incoming?.attempt_revision ?? -1) ||
      Number(previous?.state_revision ?? -1) > Number(incoming?.state_revision ?? -1) ||
      (previous?.phase === "finished" && incoming?.phase !== "finished"))) {
    return previous;
  }
  return incoming;
}
